import {chartTokens} from './chart';

export const tokens = {
  text: {
    title: {
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '20px',
      letterSpacing: '-0.006em',
    },
    subtitle: {
      fontSize: '13px',
      fontWeight: 400,
      lineHeight: '18px',
      letterSpacing: '-0.003em',
    },
    metadata: {
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '16px',
      letterSpacing: '0em',
    },
    heading: {
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '22px',
    },
    label: {
      fontSize: '12px',
      fontWeight: 600,
      lineHeight: '16px',
      letterSpacing: '0.05em',
      textTransform: 'uppercase' as const,
    },
    badge: {
      fontSize: '12px',
      fontWeight: 500,
      lineHeight: '16px',
      letterSpacing: '0.01em',
    },
  },

  control: {
    height: 32,
  },

  radius: {
    sm: 4,
    md: 6,
    lg: 8,
    badge: 4,
  },

  transition: {
    fast: '100ms cubic-bezier(0.4, 0, 0.2, 1)',
    normal: '150ms cubic-bezier(0.4, 0, 0.2, 1)',
    slow: '200ms cubic-bezier(0.4, 0, 0.2, 1)',
  },

  shadow: {
    sm: 'var(--shadow-sm)',
    md: 'var(--shadow-md)',
    lg: 'var(--shadow-lg)',
    popover: 'var(--shadow-popover)',
    focusSm: 'var(--shadow-focus-sm)',
  },

  spacing: {
    gap: {xs: 4, sm: 8, md: 12, lg: 16},
    listItem: {
      sm: {py: 6, px: 12},
      md: {py: 10, px: 12},
      lg: {py: 12, px: 16},
    },
  },

  colors: {
    interactive: {
      hover: 'var(--interactive-hover)',
      active: 'var(--interactive-active)',
      selected: 'var(--interactive-selected)',
      selectedHover: 'var(--interactive-selected-hover)',
      highlighted: 'var(--interactive-highlighted)',
    },
    role: {
      admin: '#6366f1',
      manager: '#8b5cf6',
      member: '#ec4899',
      concierge: '#f59e0b',
      default: '#6b7280',
    },
    badge: {
      default: {bg: 'var(--badge-default-bg)'},
      primary: {bg: 'var(--badge-primary-bg)'},
      success: {bg: 'var(--badge-success-bg)'},
      warning: {bg: 'var(--badge-warning-bg)'},
      error: {bg: 'var(--badge-error-bg)'},
      info: {bg: 'var(--badge-info-bg)'},
    },
    surface: {
      text: 'var(--surface-text)',
      textMuted: 'var(--surface-text-muted)',
      textSecondary: 'var(--surface-text-secondary)',
      bg: 'var(--surface-bg)',
      bgHover: 'var(--surface-bg-hover)',
      bgAlt: 'var(--surface-bg-alt)',
      border: 'var(--surface-border)',
      borderHover: 'var(--surface-border-hover)',
      borderDashed: 'var(--surface-border-dashed)',
    },
    gradient: {
      blockSuggestion: 'var(--gradient-block-suggestion)',
      homeSuggestion: 'var(--gradient-home-suggestion)',
    },
    insight: {
      warning: {
        bg: 'var(--insight-warning-bg)',
        border: 'var(--insight-warning-border)',
      },
      error: {
        bg: 'var(--insight-error-bg)',
        border: 'var(--insight-error-border)',
      },
      info: {
        bg: 'var(--insight-info-bg)',
        border: 'var(--insight-info-border)',
      },
      note: {
        bg: 'var(--insight-note-bg)',
        border: 'var(--insight-note-border)',
      },
    },
  },

  chart: chartTokens,
};
